import axios, { AxiosInstance } from 'axios';

export class APIClient {
  private client: AxiosInstance;
  private endpointUrl: string;

  constructor(endpointUrl: string) {
    this.client = axios.create({
      baseURL: 'https://us-central1-esscents-7dbc7.cloudfunctions.net/app',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    this.endpointUrl = endpointUrl;
  }

  public async post<T>(params: {
    requestBody: T;
  }): Promise<T> {
    try {
      const response = await this.client.post<T>(this.endpointUrl, params.requestBody);
      return response.data;
    } catch (error) {
      console.error(`Error making POST request to ${this.endpointUrl} with request body ${params.requestBody}:`, error);
      throw error;
    }
  }
}
